import React from 'react'
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';
import { getCookie } from "../services/Cookies";
import { logUserActivity } from "../services/FunctionServices";

const RouteChangeTracker = ({ history }) => {
    //let pathname=history.location.pathname;
    console.log(window.location.href);
    if (window.location.href.indexOf('sign-in') == -1 && window.location.href.indexOf('forgot') == -1 && window.location.href.indexOf('sign-up') == -1) {
        let arr = window.location.href.split("/");
        let path = "";
        for (var i = 0; i < arr.length; i++) {
            if (i > 2)
                path = path + "/" + arr[i];
        }
        if (path !== "/") {
           logUserActivity(path);
        }
    }
    // console.log(history);
    history.listen((location, action) => {
        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname, {
            userId: getCookie('username'),
            username: getCookie('username').split('@')[0],
            userdomain: getCookie('username').split('@')[1],
            usertype: getCookie('type'),
            userrole: getCookie('userRole'),
            userclientname: getCookie('clientName'),
            userservice: getCookie('serviceTypes'),
            bM_ACCESS_STATUS: getCookie('bM_ACCESS_STATUS'),
            GlobalFilterSetting: getCookie('globalFilerSetting')
        })
    });

    return <div></div>
};

export default withRouter(RouteChangeTracker);